import { Link } from 'react-router-dom';
import { VideoItem } from '@/mocks/videos';

interface RankingSectionProps {
  videos: VideoItem[];
}

export default function RankingSection({ videos }: RankingSectionProps) {
  const ranked = [...videos].sort((a, b) => b.views - a.views).slice(0, 10);

  return (
    <section className="py-10 md:py-14 bg-background-100/50">
      <div className="container-site">
        <div className="flex items-center justify-between mb-6">
          <div>
            <h2 className="text-xl md:text-2xl font-bold text-foreground-950 font-heading">
              热门排行
            </h2>
            <p className="text-sm text-foreground-500 mt-1">根据播放量排序的热门内容</p>
          </div>
          <div className="flex items-center gap-2">
            <span className="text-xs text-foreground-500 flex items-center gap-1">
              <i className="ri-fire-line text-primary-500"></i>
              实时更新
            </span>
          </div>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
          {ranked.slice(0, 5).map((video, index) => (
            <Link
              key={video.id}
              to={`/article/${video.id}`}
              className="group flex items-center gap-4 p-3 rounded-lg hover:bg-background-200/50 transition-colors cursor-pointer"
            >
              <div className={`flex-shrink-0 w-8 h-8 md:w-10 md:h-10 flex items-center justify-center rounded-lg font-bold text-lg ${
                index === 0 ? 'bg-accent-500 text-background-50 dark:text-foreground-950' :
                index === 1 ? 'bg-secondary-400 text-background-50 dark:text-foreground-950' :
                index === 2 ? 'bg-secondary-500 text-background-50 dark:text-foreground-950' :
                'bg-background-200 text-foreground-600'
              }`}>
                {index + 1}
              </div>
              <div className="relative overflow-hidden rounded-lg w-32 md:w-40 aspect-video flex-shrink-0">
                <img
                  src={video.thumbnail}
                  alt={video.title}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                  loading="lazy"
                />
                <div className="absolute bottom-1 right-1 px-1.5 py-0.5 bg-black/70 rounded text-[10px] text-foreground-200 whitespace-nowrap">
                  {video.duration}
                </div>
              </div>
              <div className="flex-1 min-w-0">
                <h3 className="text-sm font-semibold text-foreground-900 group-hover:text-primary-500 transition-colors line-clamp-2">
                  {video.title}
                </h3>
                <div className="flex items-center gap-2 mt-1.5 text-xs text-foreground-500 flex-wrap">
                  <span className="flex items-center gap-1">
                    <i className="ri-star-fill text-accent-500 text-[10px]"></i>
                    {video.rating}
                  </span>
                  <span>{video.views.toLocaleString()}次播放</span>
                  <span className="text-foreground-600">{video.quality}</span>
                </div>
                <p className="text-xs text-foreground-500 mt-1 line-clamp-1">{video.description}</p>
              </div>
            </Link>
          ))}
        </div>

        <div className="mt-6 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-3">
          {ranked.slice(5).map((video, index) => (
            <Link
              key={video.id}
              to={`/article/${video.id}`}
              className="group flex items-center gap-3 p-2 rounded-lg hover:bg-background-200/50 transition-colors cursor-pointer"
            >
              <span className="flex-shrink-0 w-7 h-7 flex items-center justify-center rounded text-xs font-bold bg-background-200 text-foreground-600">
                {index + 6}
              </span>
              <div className="flex-1 min-w-0">
                <h4 className="text-xs font-medium text-foreground-800 group-hover:text-primary-500 transition-colors line-clamp-1">
                  {video.title}
                </h4>
                <span className="text-[10px] text-foreground-500">{video.views.toLocaleString()}次</span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}